module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-01-65196947c4a6f5177a16982e1fb8c64a.png";